export default "__VITE_ASSET__CbeX9nRt__"